import { Autocomplete, Box, Button, Checkbox, FormControl, IconButton, Stack, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from '@mui/material'
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../global/config/store'
import { setSelectedClientGroup } from '../../../global/config/Reducer/clientSlice.ts'
import { ApiGetClientEntityByClientGroupId, ApiReportTempToken, GetClientEntityQuestions } from '../../../apiService/Core/Apicall.tsx'
import { setDate } from '../../../global/config/Reducer/dateSlice.ts'
import { ApiAppproveAndSendEmailtoAldi, ApigetReportQuestionsAnswers, ApiUpdateReportStatus } from '../../../apiService/Core/CustomApiManageReports.tsx'
import { toast } from 'react-toastify'
import { Edit } from '@mui/icons-material'
import { setSelectedRegionData } from '../../../global/config/Reducer/regionSlice.ts'

function ManageReportQuestions() {
    const Clientlist = useSelector((state: RootState) => state.client.clientList)
    const selectedClientName = useSelector((state: RootState) => state.client.selectedClient)
    const selectedDateRedux = useSelector((state: RootState) => state.date.selectedDate)

    const [selectedClient, setSelectedClient] = useState<any>(selectedClientName)
    const [clientEntityList, setClientEntityList] = useState<any>([])
    const [clientEntityId, setClientEntityId] = useState<any>(null)
    const [currentDate, setCurrentDate] = useState(new Date(selectedDateRedux))
    const [questionslist, setQuestionList] = useState([])
    const [answerlist, setAnswerlist] = useState<any>([])
    const [selectedQuestion, setSelectedQuestion] = useState<any>()
    const [selectedAnswer, setSelectedAnswer] = useState<any>()
    const [data, setData] = useState([])
    const isSpecialClient = selectedClientName?.clientGroupName === "ALDI";
    const [regions, setRegions] = useState<any[]>([])
    const [selectedRegion, setSelectedRegion] = useState<any>();
    const [selectedVenues, setSelectedVenues] = useState<any[]>([]);
    const userId: any = localStorage.getItem("userId");







    const dispatch = useDispatch()


    useEffect(() => {
        selectedClientName && setSelectedClient(selectedClientName)
    }, [selectedClientName])

    useEffect(() => {
        if (selectedClient?.clientGroupName) {
            handleGetClientList()
        }
    }, [selectedClient?.clientGroupName])


    const handleGetClientList = async () => {
        const data = `?ClientGroupName=${selectedClientName?.clientGroupName}`
        if (!selectedClient?.clientGroupName) return
        try {
            const res: any = await ApiGetClientEntityByClientGroupId(data)
            setRegions([]);
            setClientEntityList(res.data)
        } catch (error) {
            console.error("Error during API call:", error)
        }
    }


    const handlePrevMonth = () => {
        setCurrentDate((prevDate) => {
            const newDate = new Date(prevDate.getFullYear(), prevDate.getMonth() - 1, 1)
            dispatch(setDate(newDate))
            return newDate
        })
    }

    const handleNextMonth = () => {
        setCurrentDate((prevDate) => {
            const newDate = new Date(prevDate.getFullYear(), prevDate.getMonth() + 1, 1)
            dispatch(setDate(newDate))
            return newDate
        })
    }


    const formatDate = (date: Date) => {
        return `${date?.getFullYear()}-${String(date?.getMonth() + 1).padStart(2, "0")}`
    }


    const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newDate = new Date(event.target.value + "-01")
        dispatch(setDate(new Date(newDate)))
        setCurrentDate(newDate)
    }


    const getQuestions = async () => {
        try {
            const res = await GetClientEntityQuestions(clientEntityId)
            // const data = `?month=${currentDate?.getMonth() + 1}&year=${currentDate?.getFullYear()}&clientEntityId=${clientEntityId}&questionId=${selectedQuestion}&answerValue=${selectedAnswer}`
            // const res = await ApigetReportQuestionsAnswers(data, selectedClient?.clientGroupName)
            if (res?.status) {
                setQuestionList(res?.data?.filter((item: any) => item?.questionId?.qOptionJson?.length > 0))
            }
        } catch (error: any) {
            console.error("Error during API call:", error)
            toast.error(error)
        }
    }
    const getReportQuestionData = async () => {
        try {
            const data = `?month=${currentDate?.getMonth() + 1}&year=${currentDate?.getFullYear()}&clientEntityId=${clientEntityId}&questionId=${selectedQuestion}&answerValue=${selectedAnswer}`
            const data2 = {
                month: currentDate?.getMonth() + 1,
                year: currentDate?.getFullYear(),
                clientEntityId: clientEntityId,
                questionId: selectedQuestion,
                answerValue: selectedAnswer,
                regionId:selectedRegion?.value
            }
            console.log("RegionId", selectedRegion?.value)
            const res = await ApigetReportQuestionsAnswers(data2, selectedClient?.clientGroupName)
            if (res?.status) {
                setData(res?.data)
            }
        } catch (error: any) {
            console.error("Error during API call:", error)
            toast.error(error)
        }
    }
    useEffect(() => {
        clientEntityId && currentDate && getQuestions()
    }, [clientEntityId, currentDate])

    useEffect(() => {
        clientEntityId && currentDate && selectedAnswer && selectedQuestion && getReportQuestionData()
    }, [clientEntityId, currentDate, selectedAnswer, selectedQuestion,selectedRegion])


    const OpenEditReport = async (item: any) => {
        try {
            const data = {
                reportHeaderId: item.reportHeaderId,
                allocationId: item.allocationId,
                clientGroupName: selectedClient?.clientGroupName
            }
            const res = await ApiReportTempToken(data)
            if (res.success) {
                sessionStorage.setItem('fromOriginalSite', 'true');
                window.open(`${process.env.REACT_APP_SHOPPER_SITE}?x-z-a=${res?.data?.token}`, '_blank');
            }
            else {
                toast.error(res?.message)
            }
        } catch (error: any) {
            toast.error(error?.message)
        }
    }



    const isSelected = (venue: any) =>
        selectedVenues.some((v) => v?.venueId === venue?.venueId); // use your unique key (id)

    const handleSelectVenue = (venue: any) => {
        setSelectedVenues((prev) =>
            prev.some((v) => v?.venueId === venue?.venueId)
                ? prev.filter((v) => v?.venueId !== venue?.venueId) // remove
                : [...prev, venue] // add
        );
    };

    const allSelected = data?.length > 0 && selectedVenues.length === data.length;
    const someSelected = selectedVenues.length > 0 && !allSelected;

    const handleSelectAll = (checked: boolean) => {
        setSelectedVenues(checked ? [...(data || [])] : []);
    };

    const OliveButton = ({
        children,
        ...props
    }: React.ComponentProps<typeof Button>) => (
        <Button
            {...props}
            sx={{
                backgroundColor: "#7a7d52",
                color: "white",
                "&:hover": {
                    backgroundColor: "#5e6040",
                },
                textTransform: "none",
                ...props.sx,
            }}
            variant="contained"
        >
            {children}
        </Button>
    );


    const handleReleased = async () => {
        const isConfirmed = window.confirm("Are you sure you want to Release selected reports?"
        );

        if (isConfirmed) {
            const results = selectedVenues
                .map(selectedItem => {
                    return selectedItem ? {
                        reportHeaderId: selectedItem.reportHeaderId,
                        canClientEditReports: false
                    } : null;
                })
                .filter(Boolean);

            try {
                const data = {
                    reportHeader: results,
                    status: 'rel',
                    approvedBy: Number(userId)
                };

                if (selectedVenues.length === 0) {
                    alert("Please select at least one report to release");
                    return;
                }

                const response = await ApiUpdateReportStatus(data, selectedClient?.clientGroupName);
                if (response?.success || response?.status) {
                    toast.success("Status updated successfully");
                    getReportQuestionData()
                }
            } catch (error) {
                console.error("Error updating status:", error);
            } finally {
                setSelectedVenues([]);
            }
        }
    };



    const handleAPrroveandSendMailtoAldi = async () => {
        if (selectedVenues.length === 0) {
            alert("Please select at least one report to approve and send to ALDI");
            return;
        }
        const isConfirmed = window.confirm(
            "Are you sure you want to Approve this Reports and Send mail to ALDI?"
        );
        if (isConfirmed) {
            try {
                const selectedAllocationIds =
                    selectedVenues?.map(item => item.allocationId);

                const data = { allocationIds: selectedAllocationIds };
                const response = await ApiAppproveAndSendEmailtoAldi(data, "ALDI");

                toast.success("Status updated successfully");
                getReportQuestionData()
            } catch (error) {
                console.error("Error updating status:", error);
                toast.error("Error processing ALDI reports");
            } finally {
                setSelectedVenues([]);
            }
        }
    };

    return (
        <div className="w-100 px-2 py-0 py-md-3">
            <Box className='w-100 border-10 bg-white p-2 py-5'>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        // marginBottom: {xs:"0px",md:"-70px"},
                        flexWrap: 'wrap',
                        gap: 2,
                        marinTop: "23px",
                    }}
                >
                    <Stack direction="row" flexWrap={{ xs: "wrap", md: "nowrap" }} gap={1}>
                        <FormControl size="small" sx={{ width: { xs: "100%", md: 180 } }}>
                            <Autocomplete
                                disablePortal
                                id="mm-autocomplete"
                                options={Clientlist}
                                value={selectedClient}
                                getOptionLabel={(option) => option?.clientGroupName}
                                isOptionEqualToValue={(option, value) => option.clientGroupDBName === value.clientGroupDBName}
                                onChange={(event, newValue: any) => {
                                    // setSelectedClient(newValue)
                                    dispatch(setSelectedClientGroup(newValue))
                                    setClientEntityId(null)
                                    setData([])
                                    setClientEntityList([])
                                    setQuestionList([])
                                    setAnswerlist([])
                                    setSelectedAnswer(null)
                                    setSelectedQuestion(null)
                                }}
                                // defaultValue="mmcommon"
                                renderInput={(params) => <TextField {...params} label="Select Client" />}
                                size="small"
                            />
                        </FormControl>
                        <FormControl size="small" sx={{ width: { xs: "100%", md: 180 } }}>
                            <Autocomplete
                                disablePortal
                                id="beacon-autocomplete"
                                options={clientEntityList.filter((item: any) => item.clientEntityId !== null)}
                                getOptionLabel={(option) => option?.entityName || ""}
                                onChange={(event, newValue: any) => {
                                    setClientEntityId(newValue?.clientEntityId || null)

                                    if (newValue?.entityName === "Liquor ID") {
                                        sessionStorage.setItem("isLiquor", "true");
                                    } else {
                                        sessionStorage.setItem("isLiquor", "false");
                                    }
                                    if (!newValue) {
                                        setQuestionList([])
                                        setAnswerlist([])
                                        setData([])
                                        setSelectedAnswer(null)
                                        setSelectedQuestion(null)
                                        setRegions([]);
                                        setSelectedRegion(null);
                                        sessionStorage.setItem("isLiquor", "false");
                                    }
                                    else if (isSpecialClient && newValue?.regions) {
                                        const regionOptions = newValue.regions.map((region: any) => ({
                                            label: region.regionName,
                                            value: region.regionId
                                        }));
                                        setRegions(regionOptions);
                                        setSelectedRegion(null);
                                    }
                                    else {
                                        setRegions([]);
                                        setSelectedRegion(null);
                                    }
                                }
                                }
                                value={clientEntityList.find((option: any) => option?.clientEntityId === clientEntityId) || null}
                                renderInput={(params) => <TextField {...params} label="Select Business" />}
                                size="small"
                            />
                        </FormControl>
                        {isSpecialClient && (
                            <Autocomplete
                                size="small" sx={{ width: { xs: "100%", md: 180 } }}
                                options={regions}
                                value={selectedRegion}
                                onChange={(event, newValue: any) => {
                                    setSelectedRegion(newValue);
                                    dispatch(setSelectedRegionData(newValue))
                                }}
                                getOptionLabel={(option) => option.label || ''}
                                renderInput={(params) => (
                                    <TextField {...params} label="Select Region" />
                                )}
                            />
                        )}
                    </Stack>
                    <h1 style={{ textAlign: "center" }}>Manage Report Questions</h1>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            // marginBottom: "70px",
                        }}
                    >
                        <IconButton onClick={handlePrevMonth}>
                            <ChevronLeftIcon />
                        </IconButton>
                        <Box sx={{ display: "flex", alignItems: "center", mx: 2 }}>
                            <input
                                type="month"
                                value={formatDate(currentDate)}
                                onChange={handleDateChange}
                                className="primary-color"
                                style={{
                                    border: "none",
                                    background: "none",
                                    fontSize: "1.25rem",
                                    fontWeight: "bold",
                                    cursor: "pointer",
                                    fontFamily: "inherit",
                                }}
                            />
                        </Box>
                        <IconButton onClick={handleNextMonth}>
                            <ChevronRightIcon />
                        </IconButton>
                    </Box>
                </Box>
                <Box className='my-2 mt-4'>
                    <Stack direction="row" flexWrap={{ xs: "wrap", md: "nowrap" }} gap={1}>
                        <FormControl size="small" sx={{ width: { xs: "100%", md: '50%' } }}>
                            <Autocomplete
                                disablePortal
                                id="mm-autocomplete"
                                options={questionslist || []}
                                value={
                                    questionslist?.find(
                                        (item: any) =>
                                            item?.questionId?.questionId === selectedQuestion
                                    ) || null
                                }
                                getOptionLabel={(option: any) =>
                                    option?.questionId?.questions || ""
                                }
                                isOptionEqualToValue={(option: any, value: any) =>
                                    option?.questionId?.questionId === value?.questionId?.questionId
                                }
                                onChange={(_event, newValue: any) => {
                                    const questionId = newValue?.questionId?.questionId || null;
                                    setData([])

                                    // Store only questionId
                                    setSelectedQuestion(questionId);

                                    // Set answers
                                    try {
                                        const options = JSON.parse(
                                            newValue?.questionId?.qOptionJson || "[]"
                                        );
                                        setAnswerlist(Array.isArray(options) ? options : []);
                                    } catch (error) {
                                        console.error("Invalid qOptionJson:", error);
                                        setAnswerlist([]);
                                    }
                                }}
                                renderInput={(params) => (
                                    <TextField {...params} label="Select Question" />
                                )}
                                size="small"
                            />
                        </FormControl>
                        <FormControl size="small" sx={{ width: { xs: "100%", md: '50%' } }}>
                            <Autocomplete
                                disablePortal
                                id="beacon-autocomplete"
                                options={answerlist}
                                getOptionLabel={(option) => option?.value || ""}
                                onChange={(event, newValue: any) => {
                                    setSelectedAnswer(newValue?.value || null)
                                }}
                                value={answerlist.find((option: any) => option?.value === selectedAnswer) || null}
                                renderInput={(params) => <TextField {...params} label="Select Answers" />}
                                size="small"
                            />
                        </FormControl>
                    </Stack>
                </Box>

                <Box sx={{ display: "flex", justifyContent: "flex-end", my: 2, px: 2, gap: 1 }}>
                    <OliveButton onClick={() => { handleReleased() }}>Release Selected</OliveButton>
                    {selectedClient?.clientGroupName === "ALDI" && (<OliveButton onClick={() => { handleAPrroveandSendMailtoAldi() }}>Release Selected and Send to ALDI</OliveButton>)}
                </Box>

                <Box className='mt-5'>
                    <Table>
                        <TableHead>
                            <TableRow className="table-row-background">
                                {[
                                    "checkbox",
                                    "Site",
                                    isSpecialClient && "Region",
                                    "Report Status",
                                    "Edit",
                                ].filter(Boolean).map((item, index) => (
                                    <TableCell className={`${index == 1 ? "w-50" : ""}`} key={index} style={{ color: "#fff" }}>
                                        {/* <Box className={`${index > 1 ? "d-flex justify-content-end pr-5" : ""}`}>
                                            {item}
                                        </Box> */}
                                        {item === "checkbox" ? (
                                            <Checkbox
                                                size="small"
                                                sx={{ color: "#fff", "&.Mui-checked, &.MuiCheckbox-indeterminate": { color: "#fff" } }}
                                                checked={allSelected}
                                                indeterminate={someSelected}
                                                onChange={(e) => handleSelectAll(e.target.checked)}
                                            />
                                        ) : (
                                            <Box className={`${index > 1 ? "d-flex justify-content-center" : ""}`}>
                                                {item}
                                            </Box>
                                        )}
                                    </TableCell>
                                ))}
                                {/* <TableCell></TableCell> */}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data?.length > 0 ? data?.map((venue: any) => {
                                const checked = isSelected(venue);
                                return (
                                    <TableRow>
                                        <TableCell padding="checkbox">
                                            <Checkbox
                                                size="small"
                                                checked={checked}
                                                onChange={() => handleSelectVenue(venue)}
                                            />
                                        </TableCell>
                                        <TableCell className='w-50' >{venue?.venueName}</TableCell>
                                        {isSpecialClient &&
                                            <TableCell>
                                                <Box className='d-flex justify-content-center'>
                                                    {venue?.region}
                                                </Box>
                                            </TableCell>}
                                        <TableCell>
                                            <Box className='d-flex justify-content-center'>
                                                {venue?.reportStatus}
                                            </Box>
                                        </TableCell>
                                        <TableCell>
                                            <Box className='d-flex justify-content-center'>
                                                <IconButton onClick={() => { OpenEditReport(venue) }}><Edit /></IconButton>
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                )
                            }) : (
                                (
                                    <TableRow><TableCell colSpan={12}><Typography className='text-center'>No Data Found</Typography></TableCell></TableRow>
                                )
                            )}
                        </TableBody>
                    </Table>
                </Box>
            </Box>
        </div>
    )
}

export default ManageReportQuestions
